import React, { useEffect, useState } from 'react';
import { Button, Card, Spin } from 'antd';
import type { Scholarship } from '~/models/Scholarship';
import ScholarshipsAPI from '~/services/ScholarshipsAPI';
import { useParams } from 'react-router-dom';


const ScholarshipDetailView: React.FC = () => {
    const { scholarshipSlug } = useParams<{ scholarshipSlug: string }>();
    const [scholarship, setScholarship] = useState<Scholarship | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const fetchScholarship = async () => {
            try {
                const response = await ScholarshipsAPI.getSlug(scholarshipSlug || '');
                setScholarship(response.data.scholarship);
            } catch (error) {
                console.error('Failed to fetch scholarship:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchScholarship();
    }, []);

    if (loading) {
        return <Spin style={{ display: 'block', margin: '20px auto' }} />;
    }

    if (!scholarship) {
        return <p>Scholarship not found.</p>;
    }

    return (
        <div style={{ margin: '40px auto' }}>
            <h1 style={{textAlign: 'center'}}>{scholarship.name}</h1>
            <Card
            bordered={true}
            style={{ width: 300, margin: '20px auto' }}
            >
            <p><strong>Amount:</strong> {Number(scholarship.funding_amount).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</p>
            <p><strong>Deadline:</strong> {new Date(scholarship.deadline).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
            <p><strong>Description:</strong> {scholarship.description}</p>
            
            {scholarship.scholarship_url &&
            <Button size="large"
                className="mt-3">
                <a href={scholarship.scholarship_url}
                    target="_blank"
                    rel='noopener noreferrer'>
                    Visit Scholarship Website
                </a>
            </Button>
            
            }
            </Card>
        </div>
    );
};

export default ScholarshipDetailView;